import React, { useState, useEffect } from 'react'

// Deps
import omit from 'lodash/omit'

// Functions
// import formatDate from 'functions/format-date';

// Partials
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Loader from 'views/shared/partials/loader'
// import { Table, TR, TD } from 'views/shared/partials/table'
// import Pricebox from 'views/shared/partials/pricebox'

// Services
import companyServices from 'services/company'

// Data
import paymentTypeOptions from 'data/payment-types'

const booleanOptions = [
	{
		value: '1',
		label: 'Evet',
	},
	{
		value: '0',
		label: 'Hayır',
	}
]

const CompanyPaymentTypeModal = (props) => {
	const close = props.close;
	const paymentTypeID = props.paymentTypeID;

	const [submitting, setSubmitting] = useState(false);
	const [gettingTemplate, setGettingTemplate] = useState(false);
	const [typeInfo, setTypeInfo] = useState(false);
	const [selectedPaymentType, setSelectedPaymentType] = useState(paymentTypeID ? false : paymentTypeOptions[7]);
	const [selectedPaymentTemplate, setSelectedPaymentTemplate] = useState(false);
	const [templateFieldData, setTemplateFieldData] = useState({});

	useEffect(() => {
		if(paymentTypeID) {
			companyServices.getCompanyPaymentType(paymentTypeID).then((payload) => {

				setTypeInfo({...payload, data: JSON.parse(payload.data_json)});
				setSelectedPaymentType(paymentTypeOptions.find((opt) => {
					return opt.value === payload.payment_type.id.toString();
				}));
			}).catch(() => { close(); })
		}
		else {
			setTypeInfo(null);
		}
	}, [paymentTypeID, close]);

	useEffect(() => {
		if(
			selectedPaymentType &&
			typeInfo !== false &&
			(
				!selectedPaymentTemplate ||
				(selectedPaymentTemplate && selectedPaymentType.value !== selectedPaymentTemplate.id.toString())
			)
		) {
			const mergeTypeTemplate = (typeTemplate) => {
				if (typeTemplate.id.toString() === selectedPaymentType.value) {
					let fields = [];
					let fieldData = {}

					let templateJSON = JSON.parse(typeTemplate.data_template)
					let typesJSON = JSON.parse(typeTemplate.data_template_ux)
					
					if(!templateJSON) {templateJSON = {}; }
					if(!typesJSON) { typesJSON = {}; }

					let fieldJSON = templateJSON;

					if (typeInfo && typeInfo.data) {
						fieldJSON = { ...fieldJSON, ...typeInfo.data };
					}

					if (fieldJSON) {
						for (let dataKey of Object.keys(templateJSON)) {
							// Reference object is kept as templateJSON in order to keep unwanted fields if the template data changes.
							let fieldValue = fieldJSON[dataKey].trim().toString();
							let fieldType = typesJSON[dataKey] ? typesJSON[dataKey].type : 'text';
							let fieldOptions = undefined;
							let fieldLabel = typesJSON[dataKey] ? typesJSON[dataKey].title : dataKey;

							fieldData[dataKey] = fieldValue;

							if(fieldType === 'select') {
								fieldOptions = typesJSON[dataKey] ? typesJSON[dataKey].options : booleanOptions;
								fieldValue = fieldOptions.find((opt) => (opt.value.toString() === fieldValue))
							}

							fields.push({
								key: dataKey,
								value: fieldValue,
								label: fieldLabel,
								type: fieldType,
								options: fieldOptions,
								conditions: (typesJSON[dataKey] && typesJSON[dataKey].conditions) ? typesJSON[dataKey].conditions : false,
							});
						};
					}

					setSelectedPaymentTemplate({ ...typeTemplate, fields: fields });
					setTemplateFieldData(fieldData);
					setGettingTemplate(false);
				}
			}

			
			setGettingTemplate(true);
			if(!typeInfo) {
				companyServices.getPaymentType(selectedPaymentType.value).then((payload) => {
					mergeTypeTemplate(payload);
				}).catch(() => {
					setGettingTemplate(false);
				});
			}
			else {
				mergeTypeTemplate(typeInfo.payment_type);
			}
		}
	}, [selectedPaymentType, typeInfo, selectedPaymentTemplate]);

	const updateTemplateFieldData = (field, value) => {		
		let newFieldData = {...templateFieldData};
		newFieldData[field] = value;
		setTemplateFieldData(newFieldData);
	}

	const checkTemplateFieldConditions = (field) => {
		let status = true;

		if(field.conditions) {
			for(const condition of field.conditions) {
				if(status === true) {
					if(condition.condition === 'equals') {
						status = condition.value.includes(templateFieldData[condition.field])
					}
					else if(condition.condition === 'inequal') {
						status = !condition.value.includes(templateFieldData[condition.field])
					}
				}
			}
		}

		return status;
	}

	const submit = (formData) => {
		setSubmitting(true);

		let dataFields = omit(formData, ['api_name', 'payment_type_id', 'company_payment_type_id', 'amex', 'iyzico_key'])

		for (const field of selectedPaymentTemplate.fields) {
			if(field.value.length && dataFields[field.key] && !dataFields[field.key].length) {
				dataFields[field.key] = field.value;
			}
		}

		let payload = {
			api_name: formData.api_name, 
			payment_type_id: formData.payment_type_id,
			data: dataFields,
			amex: formData.amex ? '1' : '0',
		};

		if(typeInfo && typeInfo.id) {
			payload.company_payment_type_id = typeInfo.id;
		}

		if (selectedPaymentType.value === '9') {
			payload.iyzico_key = formData.iyzico_key;
		}

		companyServices.createOrUpdatePaymentType(payload).then(() => {
			if(props.onSuccess) {
				props.onSuccess();
			}
			props.close();
		}).catch(() => {
		}).finally(() => {
			setSubmitting(false);
		})
	}

	return (
		<InputForm
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">{props.paymentTypeID ? 'Ödeme Yöntemini Düzenle' : 'Ödeme Yöntemi Oluştur'}</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content loader-container">
				<Loader loading={!selectedPaymentTemplate || typeInfo === false} />
				{typeInfo !== false && selectedPaymentTemplate &&
					<div className="grid-container">
						<div className="row">
							<div className="col x12">
								<FormInput
									type="select"
									z={selectedPaymentTemplate.fields ? (selectedPaymentTemplate.fields.length + 1) : '1'}
									label="Ödeme Türü"
									name="payment_type_id"
									validation={{
										required: 'Bir ödeme türü seçmelisiniz.',
									}}
									disabled={submitting}
									readOnly={!(!typeInfo)}
									value={selectedPaymentType}
									onChange={(opt) => { setSelectedPaymentType(opt); }}
									options={paymentTypeOptions} />
							</div>
						</div>
						<div className="row">
							<div className="col x12">
								<FormInput
									type="text"
									disabled={gettingTemplate || submitting}
									label="API Adı"
									name="api_name"
									value={typeInfo ? typeInfo.api_name : undefined}
									validation={{
										required: 'Bir API adı girmelisiniz.',
									}} />
							</div>
						</div>
						{selectedPaymentTemplate.fields.map((field, nth) => (
							<React.Fragment key={nth}>
								{checkTemplateFieldConditions(field) &&
									<div className="row">
										<div className="col x12">
											{field.type === 'select' ?
												<FormInput
													z={(selectedPaymentTemplate.fields.length - nth).toString()}
													type="select"
													disabled={gettingTemplate || submitting}
													label={field.label}
													name={field.key}
													options={field.options}
													value={field.value}
													onChange={(opt) => { updateTemplateFieldData(field.key, opt.value); }}
													validation={{
														required: 'Bir '+field.label+' seçeneği seçmelisiniz.',
													}} />
												:
												<FormInput
													type="text"
													disabled={gettingTemplate || submitting}
													label={field.label}
													name={field.key}
													value={(field.value && field.value.length) ? field.value : undefined}
													onChange={(val) => { updateTemplateFieldData(field.key, val); }}
													validation={{
														required: 'Bir ' + field.label + ' değeri girmelisiniz.',
													}} />
											}
										</div>
									</div>
								}
							</React.Fragment>
						))}
						{(selectedPaymentType.value === '9' && templateFieldData['Pazaryeri'] === '1') &&
							<div className="row">
								<div className="col x12">
									<FormInput
										type="text"
										disabled={gettingTemplate || submitting}
										label="İyzico Submerchant Anahtarı"
										name="iyzico_key"
										value={typeInfo ? typeInfo.iyzico_key : undefined}
										validation={{
											required: 'Submerchant anahtarı alanını girmelisiniz.',
										}} />
								</div>
							</div>
						}
						<div className="row">
							<div className="col x12">
								<FormInput
									type="checkbox"
									disabled={gettingTemplate || submitting}
									checked={typeInfo && typeInfo.amex}
									label="AMEX ödemeler için kullan"
									value="1"
									name="amex" />
							</div>
						</div>
					</div>
				}
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={props.close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting || gettingTemplate}
					disabled={submitting || typeInfo === false}
					type="submit">
					{paymentTypeID ? 'Kaydet' : 'Oluştur'}
				</Btn>
			</div>
		</InputForm>
	)
}

CompanyPaymentTypeModal.defaultProps = {
	className: '',
	containerClass: 'modal-company-payment-type mobile-full',
	name: 'company-payment-type',
}

export default CompanyPaymentTypeModal